import script from "./OtpAuthenticate.vue?vue&type=script&lang=ts&setup=true"
export * from "./OtpAuthenticate.vue?vue&type=script&lang=ts&setup=true"

import "./OtpAuthenticate.vue?vue&type=style&index=0&id=b796b810&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/workspace/OneTegProdDeployment/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b796b810"]])

export default __exports__